import { Button } from "../../../components/ui/button";
    
    export const columns = [
        { key: "serviceName", label: "Service Name" },
        { key: "entityName", label: "Entity Name" },
        { key: "bookingId", label: "Booking ID" },
        { key: "bookingDate", label: "Booking Date" },
        {
            key: "downloadReport",
            label: "Report Download",
            render: () => (
                <Button
                    variant="patient.secondary"
                    size="sm"
                >
                    Download
                </Button>
            ),
        },
    ];


    export const data = [
        {
            serviceName: "Blood Test",
            entityName: "ABC Diagnostic Lab",
            bookingId: "BK1001",
            bookingDate: "12-Jan-2026",
            downloadReport: "Download",
        },
        {
            serviceName: "X-Ray Chest",
            entityName: "City Hospital",
            bookingId: "BK1002",
            bookingDate: "15-Jan-2026",
            downloadReport: "Download",
        },
        {
            serviceName: "ECG Test",
            entityName: "Heart Care Lab",
            bookingId: "BK1003",
            bookingDate: "18-Jan-2026",
            downloadReport: "Download",
        },
    ];